// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

export default function AuthCallback() {
  const { completeSession } = useAuth();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);
  const [err, setErr] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash || '';
    const m = hash.match(/session_id=([^&]+)/);
    const sid = m ? decodeURIComponent(m[1]) : null;
    if (!sid) {
      navigate('/profile', { replace: true });
      return;
    }
    (async () => {
      try {
        const user = await completeSession(sid);
        // strip the fragment and land on profile
        window.history.replaceState({}, '', '/profile');
        navigate('/profile', { replace: true, state: { user } });
      } catch (e) {
        setErr('Sign-in failed. Please try again.');
        // Clear the #session_id= fragment so App.js stops routing to AuthCallback.
        window.history.replaceState({}, '', '/profile');
        setTimeout(() => navigate('/profile', { replace: true }), 1500);
      }
    })();
  }, [completeSession, navigate]);

  return (
    <div
      data-testid="auth-callback"
      className="min-h-[80vh] flex items-center justify-center px-6"
    >
      <div className="glass-card p-6 text-center max-w-sm w-full">
        <div className="w-10 h-10 mx-auto rounded-full border-2 border-[#15291C] border-t-transparent animate-spin" />
        <p className="mt-4 text-sm font-semibold text-[#0F1A13]">
          {err ? err : 'Signing you in…'}
        </p>
      </div>
    </div>
  );
}
